import { useEffect, useRef, useState } from "react";
import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import BottomNavigationBar from "../BottomNavigation";
import "../GridFilter.css";
import "datatables.net";
import moment from "moment";
import dayjs from "dayjs";
import FilterListIcon from "@mui/icons-material/FilterList";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TablePagination } from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  setTransportList,
  setTravelType,
  setSectors,
  setActualTransportData,
} from "../../Store/Slices/countrySlice";

import $ from "jquery";
import "datatables.net";
import "datatables.net-fixedheader";
import { SendPostRequest } from "../ApiRequest";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BounceLoader } from "react-spinners";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";

import {
  setCountry,
  setCountryList,
  setAgent,
  setCity,
  setHotel,
  setArrivalDate_From,
  setArrivalDate_to,
  setCheckinDate,
  setCheckoutDate,
  setCompleted,
  setLength,
  clearFilter,
  setModalParams,
} from "../../Store/Slices/countrySlice";
import { DatePicker, Space } from "antd";
import { makePostRequest } from "../../API";
const { RangePicker } = DatePicker;

function ArrivalDepartureGridFilter() {
  const [loading, setLoading] = useState(false);
  const dateFormat = "YYYY-MM-DD";
  const storeState = useSelector((state) => state);
  const modalMapping = storeState.Country.modalMapping;
  console.log("modal mappin gis apojdsf;lja", modalMapping);
  const dispatch = useDispatch();

  const [isPlusClicked, setIsPlusClicked] = useState(false);

  const state_endpoints_mapping = {
    agent_country: {
      endpoint: "api/agent",
      field: "country_code",
      dispatchFunction: setAgent,
      dependent: "agents",
    },
    country: {
      endpoint: "api/world/cities",
      field: "country_id",
      dispatchFunction: setCity,
      dependent: "city",
    },
    city: {
      endpoint: "api/hotel",
      field: "city_id",
      dispatchFunction: setHotel,
      dependent: "hotel",
    },
    voucherId: null,
    agent: null,
    hotel: null,
    arrivalDate: null,
    returnDate: null,
    checkIn: null,
    checkOut: null,
    completed: null,
  };

  const todayDate = moment(new Date()).format(dateFormat);

  const [state, setState] = useState({
    length: 100,
    start: 0,
    draw: 1,
    voucher_id: "",
    agent_country: "",
    country: "",
    agents: "",
    city: "",
    transport: "",
    travel_type: "",
    Sector: "",
    arrival_date_from: null,
    arrival_date_to: null,
    return_date_from: null,
    return_date_to: null,
    travel_date_from: null,
    travel_date_to: null,
    completed: "no",
  });

  const Dates = {
    arrival_date: ["arrival_date_from", "arrival_date_to"],
    return_date: ["return_date_from", "return_date_to"],
    travel_date: ["travel_date_from", "travel_date_to"],
  };

  const loadData = async (state_id, value) => {
    console.log("State Id", state_id);
    if (state_endpoints_mapping[state_id] == null) return;

    setLoading(true);

    const response = await SendPostRequest(
      state_endpoints_mapping[state_id].endpoint,
      { [state_endpoints_mapping[state_id].field]: value }
    );

    console.log("Response is ", response.data);

    if (response.status == "success") {
      dispatch(
        state_endpoints_mapping[state_id].dispatchFunction(response.data)
      );
      // setState({
      //   ...state,
      //   [state_endpoints_mapping[state_id].dependent]: response.data,
      // });
    }

    setLoading(false);
  };

  const handleChange = async (e) => {
    e.preventDefault();
    console.log("Event is ", e.target.id, e.target.value);
    setState({ ...state, [e.target.id]: e.target.value });
    await loadData(e.target.id, e.target.value);
  };

  const handleDates = (e, id) => {
    console.log(e);
    if (e !== null) {
      const date_from = moment(e[0].$d).format(dateFormat);
      const date_to = moment(e[1].$d).format(dateFormat);

      // console.log("Date is :", date);
      setState({
        ...state,
        [Dates[id][0]]: date_from,
        [Dates[id][1]]: date_to,
      });
    } else {
      setState({
        ...state,
        [Dates[id][0]]: null,
        [Dates[id][1]]: null,
      });
    }
  };
  const [isFormVisible, setFormVisible] = useState(false);
  console.log("State -->", state);

  const handleFilterClick = () => {
    setFormVisible(!isFormVisible);
  };
  const tableRef = useRef(null);

  const [tableData3, setTableData3] = useState([]);

  useEffect(() => {
    const temp = () => {
      fetchData3();
    };
    temp();
  }, []);

  const fetchData = async () => {
    const endpoint = "api/umrah/allow-transport-activity";
    try {
      setLoading(true);
      const response = await SendPostRequest(endpoint, state);
      console.log("Data is <>", response);
      setLoading(false);
      // Assuming the response contains the 'data' array
      if (response && response.data && response.data.data) {
        setTableData3(response.data.data);
        console.log(tableData3, "Actual Transport......................1");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchData3 = async () => {
    const endpoint = "api/umrah/allow-transport-activity";
    const params = {
      length: 100,
      start: 0,
      draw: 1,
      
    };

    try {
      setLoading(true);
      const response = await SendPostRequest(endpoint, params);
      console.log("Data is <>", response);
      setLoading(false);
      // Assuming the response contains the 'data' array
      if (response && response.data && response.data.data) {
        setTableData3(response.data.data);
        console.log(tableData3, "Actual Transport......................1");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [expandedRows, setExpandedRows] = useState([]);

  const toggleExpansion = (index) => {
    const newExpandedRows = [...expandedRows];
    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };

  const [modalOpen, setModalOpen] = useState(false);

  const navigate = useNavigate();

  const openModal = (e) => {
    e.preventDefault();
    dispatch(setModalParams(e.target.id.split(",")));
    navigate("/datamodal");
  };

  // removeable code
  const closeModal = () => {
    setModalOpen(false);
  };

  const [modalOpen1, setModalOpen1] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);

  const openModal1 = () => {
    navigate("/AllowHotelMadina");
  };

  const openModal2 = () => {
    navigate("/AllowHotelJeddah");
  };

  const closeModal1 = () => {
    setModalOpen1(false);
  };

  const closeModal2 = () => {
    setModalOpen2(false);
  };

  // removeable code end

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // date work start

  const x = null;
  const [DateError, SetDateError] = useState({
    arivalErrorFrom: false,
    arivalError: false,
    returnFrom: false,
    returnTo: false,
    travelFrom: false,
    travelTo: false,
  });

  const handle_date_from = (e, positionFrom, ErrorPosition, StateCompare) => {
    const date_from = moment(e.$d).format(dateFormat);
    setState((prevState) => ({
      ...prevState,
      [positionFrom]: date_from,
    }));

    if (date_from && state[StateCompare] && date_from > state[StateCompare]) {
      SetDateError({
        ...DateError,
        [ErrorPosition]: true,
      });

      setState((prevState) => ({
        ...prevState,
        [positionFrom]: null,
      }));
    } else {
      SetDateError({
        ...DateError,
        [ErrorPosition]: false,
      });
    }
  };

  const handle_date_to = (
    e,
    positionto,
    DateErrorTo,
    DateErrorFrom,
    StateCompare
  ) => {
    const date_to = moment(e.$d).format(dateFormat);

    if (!state[StateCompare] || (date_to && date_to >= state[StateCompare])) {
      setState({
        ...state,
        [positionto]: date_to,
      });

      SetDateError({
        ...DateError,
        [DateErrorTo]: false,
        [DateErrorFrom]: false,
      });
    } else {
      setState({
        ...state,
        [positionto]: null,
      });

      SetDateError({
        ...DateError,
        [DateErrorTo]: true,
      });
    }
  };

  // adding a  background white when we scroll down
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // pagination layout

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  // Slice data for pagination
  const paginatedData = tableData3.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // bring it on single pages

  const [dashboardData, setDashboardData] = useState(null);
  const [apiCountry, setApiCountry] = useState([]);
  const [apiagent, setApiagent] = useState([]);
  const [counrty1, setCountry1] = useState([]);
  const [cities1, setCities1] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countries = await makePostRequest("api/world/countries");

        if (!countries) return;
        const contryList = countries.data.map((country) => {
          return [country.ISO2, country.Name];
        });
        dispatch(setCountryList(contryList));

        const transport = await makePostRequest("api/transport");
        const transportList = transport.data.map((transport) => {
          return [transport.Name, transport.UID];
        });

        dispatch(setTransportList(transportList));

        const travelType = await makePostRequest("api/travel");
        dispatch(setTravelType(Object.entries(travelType.data)));

        const sectors = await makePostRequest("api/transport/sector");
        const sectorsList = sectors.data.map((sector) => {
          return [sector.Name, sector.UID];
        });
        dispatch(setSectors(sectorsList));
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  // country
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const countries = await makePostRequest("/api/world/countries");

        const contryList = countries.data.map((country) => {
          return [country.ISO2, country.Name];
        });

        setApiCountry(contryList);
      } catch (error) {
        console.log(error?.message);
      }
    };
    fetchdata();
  }, []);

  // cities1

  // for agent

  // working

  // const handleCountryChange = async (selectedCountry) => {
  //   try {
  //     setState((prevState) => ({
  //       ...prevState,
  //       agent_country: selectedCountry,
  //     }));

  //     const response = await makePostRequest("/api/agent", {
  //       country_code: selectedCountry,
  //     });

  //     setApiagent(response?.data);
  //   } catch (error) {
  //     console.error("Error fetching agent data:", error.message);
  //   }
  // };

  const handleCountryChange = async (selectedCountry) => {
    // Reset agent list when no country is selected
    if (!selectedCountry) {
      setApiagent([]);
      return;
    }

    try {
      setState((prevState) => ({
        ...prevState,
        agent_country: selectedCountry,
      }));

      const response = await makePostRequest("/api/agent", {
        country_code: selectedCountry,
      });

      // Ensure apiagent is set to an empty array if null or undefined
      setApiagent(response?.data ?? []);
    } catch (error) {
      console.error("Error fetching agent data:", error.message);
      setApiagent([]); // Set to empty array on error
    }
  };

  // consoles

  // console.log("this is dashboard data that we get",dashboardData)

  // console.log("storeState.Country.agents",storeState.Country.agents)

  // console.log("apiagent",apiagent)
  // console.log("apiCountry",apiCountry)
  // console.log("this is state",state)

  // console.log("DateError.travelTo",DateError.travelTo)

  return (
    <div>
      <MDBContainer breakpoint=" ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="row mb-5 ">
            <div
              className={`mb-3 grid-filter-inputs flex-display-container align-items-center  sticky-top rounded  p-4 ${
                isScrolled ? "bg-white" : ""
              } `}
            >
              <h1 className="main-hading main-heading-reset">
                Arrival Deaprture TPT
              </h1>
              <button onClick={handleFilterClick} className="filter-button">
                Filters {<FilterListIcon />}
              </button>
            </div>
            <div className="row">
              <hr />
            </div>
            {isFormVisible && (
              <div className="row">
                <div className="col-md-12 mx-auto">
                  <div className="row">
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="voucher_id" className="lableSize">
                          Voucher ID
                        </label>
                        <input
                          type="text"
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          onChange={handleChange}
                          id="voucher_id"
                          name="VoucherId"
                          placeholder="Voucher ID"
                          value={state.voucher_id}
                        />
                      </div>
                    </div>
                    {/* this is agent counrty  */}

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="agent_country" className="lableSize">
                          Agent Country{" "}
                        </label>

                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="agent_country"
                          name="AgentCountry"
                          onChange={(e) => handleCountryChange(e.target.value)}
                          value={state.agent_country}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.listCountry.map((country) => {
                            return (
                              <option key={country[0]} value={country[0]}>
                                {country[1]}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    {/* this is agent  */}

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="agents" className="lableSize">
                          Agents
                        </label>

                        <select
                          className="form-control inputSize"
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          id="agents"
                          value={apiagent}
                          onChange={handleChange}
                        >
                          <option value="">Select Agent</option>
                          {state.agent_country === "" ? (
                            <option value="">Select Agent Country first</option>
                          ) : apiagent.length === 0 ? (
                            <option value="">No agent available</option>
                          ) : (
                            apiagent.map((ag) => (
                              <option key={ag.UID} value={ag.UID}>
                                {ag.FullName}
                              </option>
                            ))
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="country" className="lableSize">
                          Country{" "}
                        </label>

                        <select
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          className="form-control inputSize"
                          id="country"
                          name="Country"
                          onChange={handleChange}
                          value={state.country}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.listCountry.map((country) => (
                            <option key={country[0]} value={country[0]}>
                              {country[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="city" className="lableSize">
                          City
                        </label>

                        <select
                          className="form-control inputSize"
                          id="city"
                          name="City"
                          onChange={handleChange}
                          value={state.city}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.city.map((city) => (
                            <option key={city.UID} value={city.UID}>
                              {city.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="transport" className="lableSize">
                          Transport
                        </label>

                        <select
                          className="form-control inputSize"
                          id="transport"
                          name="Transport"
                          onChange={handleChange}
                          value={state.transport}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.transport.map((trans) => (
                            <option key={trans[1]} value={trans[1]}>
                              {trans[0]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="travel_type" className="lableSize">
                          Travel Type
                        </label>

                        <select
                          className="form-control inputSize"
                          id="travel_type"
                          name="travel_type"
                          value={state.travel_type}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                          onChange={handleChange}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.travelType.map((trans) => (
                            <option key={trans[0]} value={trans[0]}>
                              {trans[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="Sector" className="lableSize">
                          Sector
                        </label>

                        <select
                          className="form-control inputSize"
                          id="Sector"
                          name="Sector"
                          value={state.Sector}
                          onChange={handleChange}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.sectors.map((sector) => {
                            return (
                              <option key={sector[1]} value={sector[1]}>
                                {sector[0]}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    {/* ARIVAL-------------------------------------------------------------- */}

                    <label
                      for="arrival_date"
                      className="fs-1 text-center mt-3 "
                    >
                      Arrival Date
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="arrival_date" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                        >
                          <MobileDatePicker
                            value={dayjs(state.arrival_date_from, dateFormat)}
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "arrival_date_from",
                                "arivalErrorFrom",
                                "arrival_date_to"
                              )
                            }
                            className=""
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.arivalErrorFrom
                                  ? "1px solid red"
                                  : "none",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                          />
                        </DemoContainer>

                        {DateError.arivalErrorFrom ||
                        (DateError.arivalErrorFrom &&
                          state.arrival_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT ARIVAL FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>
                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.arrival_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.arivalError
                                  ? "1px solid red"
                                  : "none",
                                outline: DateError.arivalError ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "arrival_date_to",
                                "arivalError",
                                "arivalErrorFrom",
                                "arrival_date_from"
                              )
                            }
                            autoFocus={false}
                          />
                        </DemoContainer>

                        {DateError.arivalError ||
                        (DateError.arivalError &&
                          state.arrival_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT ARIVAL TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {/* end Arival  */}
                    {/* RETURN-------------------------------------------------------------- */}
                    <label
                      for="arrival_date"
                      className="fs-1 text-center mt-3 "
                    >
                      {" "}
                      Return Date{" "}
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="arrival_date" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                        >
                          <MobileDatePicker
                            value={dayjs(state.return_date_from, dateFormat)}
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "return_date_from",
                                "returnFrom",
                                "return_date_to"
                              )
                            }
                            className=""
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.returnFrom
                                  ? "1px solid red"
                                  : "none",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                          />
                        </DemoContainer>

                        {DateError.returnFrom ||
                        (DateError.returnFrom &&
                          state.return_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>
                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.return_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.returnTo
                                  ? "1px solid red"
                                  : "none",
                                outline: DateError.returnTo ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "return_date_to",
                                "returnTo",
                                "returnFrom",
                                "return_date_from"
                              )
                            }
                            autoFocus={false}
                            // Add custom class here
                          />
                        </DemoContainer>

                        {DateError.returnTo ||
                        (DateError.returnTo && state.return_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>

                    {/* TRAVEL DATE-------------------------------------------------------------- */}

                    <label
                      for="
                        travel_date"
                      className="fs-1 text-center mt-3 "
                    >
                      {" "}
                      Travel Date{" "}
                    </label>
                    <div className="col-md-2 mb-1">
                      <div className="form-group">
                        <label for="travel_date_from" className="fs-2">
                          {" "}
                          From
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "transparent",
                            },
                          }}
                        >
                          <MobileDatePicker
                            onChange={(e) =>
                              handle_date_from(
                                e,
                                "travel_date_from",
                                "travelFrom",
                                "travel_date_to"
                              )
                            }
                            value={dayjs(state.travel_date_from, dateFormat)}
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                                border: DateError.travelFrom
                                  ? "1px solid red"
                                  : "none",
                                outline: DateError.travelFrom ? "none" : "",
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "transparent",
                                  },
                              },
                            }}
                          />
                        </DemoContainer>

                        {DateError.travelFrom ||
                        (DateError.travelFrom &&
                          state.travel_date_from == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN FROM DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}

                        <label for="arrival_date" className="fs-2 mt-3">
                          {" "}
                          To
                        </label>

                        <DemoContainer
                          components={[
                            "DatePicker",
                            "MobileDatePicker",
                            "StaticDatePicker",
                          ]}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderRadius: "10px",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "transparent", // Prevents border from appearing
                              },
                            },
                          }}
                          autoFocus={false}
                        >
                          <MobileDatePicker
                            value={dayjs(state.travel_date_to, dateFormat)}
                            className=" "
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "1.3rem",
                                backgroundColor: "white",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: DateError.travelTo
                                    ? "red"
                                    : "transparent",
                                },
                                "&:hover fieldset": {
                                  borderColor: DateError.travelTo
                                    ? "red"
                                    : "gray",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: DateError.travelTo
                                    ? "red"
                                    : "#1976d2",
                                },
                              },
                            }}
                            onChange={(e) =>
                              handle_date_to(
                                e,
                                "travel_date_to",
                                "travelTo",
                                "travelFrom",
                                "travel_date_from"
                              )
                            }
                            autoFocus={false}
                          />
                        </DemoContainer>

                        {DateError.travelTo ||
                        (DateError.travelTo && state.travel_date_to == null) ? (
                          <div>
                            <p className="text-danger mt-3 f-bold ">
                              PLEASE SELECT CORRECT RETURN TO DATE
                            </p>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    {/* date section end ---------------------------------------------------------------------------------------- */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="completed" className="lableSize">
                          Completed
                        </label>
                        <select
                          className="form-control inputSize"
                          id="completed"
                          name="completed"
                          value={state.completed}
                          onChange={handleChange}
                          style={{
                            borderRadius: "8px",
                            height: "4.5rem",
                          }}
                        >
                          <option value="">Please Select</option>
                          <option value="yes">Yes</option>
                          <option value="no" selected="">
                            No
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      className="col-md-12"
                      id="AllowTransportActiviitesAjaxResult"
                    ></div>
                    <div className="col-md-12" id="FilterButtons">
                      <div className="form-group htjfdgr">
                        <button
                          style={{ marginRight: "12px", padding: "8px 25px" }}
                          onClick={fetchData}
                          id="btnsearch"
                          type="button"
                          className="btn btn-success fs-1"
                        >
                          Search
                        </button>
                        <button
                          onClick={() =>
                            setState({
                              length: 100,
                              start: 0,
                              draw: 1,
                              voucher_id: "",
                              agent_country: "",
                              country: "",
                              agents: "",
                              city: "",
                              transport: "",
                              travel_type: "",
                              Sector: "",
                              arrival_date_from: null,
                              arrival_date_to: null,
                              return_date_from: null,
                              return_date_to: null,
                              travel_date_from: null,
                              travel_date_to: null,
                              completed: "no",
                            })
                          }
                          id="btnreset"
                          type="button"
                          className="btn btn-danger  fs-1"
                          style={{ padding: "8px 25px" }}
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* old table  */}
            {/* <div style={{ marginBottom: "20px" }}>
                <Paper>
                  <Table
                    id="example"
                    className="table table-striped dt-responsive nowrap table-display"
                    // style={{ width: "100%"
                    // }}
                  >
                   




                   <TableHead>
  <TableRow className="asd">
    <TableCell sx={{ flexGrow: 1, textAlign: "center" }}>VOUCHER</TableCell>
    <TableCell sx={{ flexGrow: 1, textAlign: "center" }}>TRAVEL</TableCell>
    <TableCell sx={{ flexGrow: 1, textAlign: "center" }}>SEATS</TableCell>
    <TableCell sx={{ flexGrow: 1, textAlign: "center" }}>Vehicle_no</TableCell>
    <TableCell sx={{ flexGrow: 1, textAlign: "center" }}>Company</TableCell>
  </TableRow>
</TableHead>
<TableBody>
  {loading ? (
    <TableRow>
      <TableCell colSpan={5} align="center" style={{ height: "50vh" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <BounceLoader className="BouncingLoader" />
        </div>
      </TableCell>
    </TableRow>
  ) : (
    paginatedData?.map((item, index) => (
      <React.Fragment key={index}>
        <TableRow sx={{ fontSize: "100px !important" }}>
          <TableCell onClick={() => toggleExpansion(index)} style={{ cursor: "pointer" }}>
            {expandedRows[index] ? item.voucher_id : item.voucher_id}
          </TableCell>
          <TableCell className="table-cell">{item.activity_uid}</TableCell>
          <TableCell className="table-cell">{item.voucher_id}</TableCell>
          <TableCell className="table-cell">{item.agent}</TableCell>
          <TableCell className="table-cell">{item.arrival_date}</TableCell>
        </TableRow>

        {expandedRows[index] && (
          <TableRow>
            <TableCell className="table-cell" colSpan={5}>
              <div className="row">
                {[
                  { label: "Activity UID", value: item.activity_uid },
                  { label: "Voucher ID", value: item.voucher_id },
                  { label: "Agent", value: item.agent },
                  { label: "Arrival Date", value: item.arrival_date },
                  { label: "Return Date", value: item.return_date },
                  { label: "Country", value: item.country },
                  { label: "City Name", value: item.city_name },
                  { label: "Travel Type", value: item.travel_type },
                  { label: "Travel Date", value: item.travel_date },
                  { label: "Sector Name", value: item.sector_name },
                  { label: "No of Seats", value: item.no_of_seats },
                  { label: "Total Tax", value: item.total_pax },
                  { label: "Voucher Pilgrim", value: item.voucher_pilgrim },
                  { label: "Transport Type Name", value: item.transport_type_name },
                ].map((field, idx) => (
                  <div key={idx} className="d-flex col-6 flex-column">
                    <b className="d-block">{field.label}:</b>
                    {field.value}
                  </div>
                ))}
              </div>

              { item[0]=== "-" ? (
                <Box sx={{ display: "flex", justifyContent: "center", fontSize: "1.5rem", marginTop: "6px" }}>
                  No activity found
                </Box>
              ) : (
                <Box sx={{ display: "flex", justifyContent: "center", marginTop: "6px" }}>
                  <FormControl sx={{ width: 100 }}>
                    <InputLabel id="demo-simple-select-label">Select one</InputLabel>
                    <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Select one">
                      {Array.isArray(item[0]) &&
                        item[0].map((i, idx) => {
                          if (idx + 1 === item[0].length) return null;
                          return (
                            <button
                              id={i.action}
                              key={i.label}
                              name={i.label}
                              onClick={openModal}
                              style={{ border: "none", background: "none" }}
                            >
                              {i.label}
                            </button>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Box>
              )}
            </TableCell>
          </TableRow>
        )}
      </React.Fragment>
    ))
  )}
</TableBody>

                    <TablePagination
                      rowsPerPageOptions={[10, 15, 20]}
                      component="paper"
                      count={tableData3.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{
                        "& .MuiTablePagination-displayedRows": {
                          margin: 0, // Custom style
                        },
                        "& .MuiTablePagination-selectLabel": {
                          margin: 0, // Custom style
                        },
                        "& .MuiSelect-select": {
                          margin: 0, // Custom style
                          display: "hidden",
                        },
                      }}
                    />
                  </Table>
                </Paper>
              </div> */}

            <div style={{ marginBottom: "20px" }}>
              <Paper sx={{ padding: "0px 20px" }}>
                <Table
                  id="example"
                  className="table table-striped dt-responsive nowrap table-display w-100"
                >
                  {/* Table Head */}
                  <TableHead>
                    <TableRow>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        Voucher
                      </TableCell>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        Travel Date
                      </TableCell>
                      <TableCell component="th" sx={{ fontWeight: "bold" }}>
                        Travel Type
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  {/* Table Body */}
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          align="center"
                          style={{ height: "35vh" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <BounceLoader className="BouncingLoader" />
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                    
                    
                    
                     
                                          : paginatedData?.length === 0 ? (
                                                                                  <TableRow>
                                                                                    <TableCell colSpan={3} align="center" style={{ height: "25vh" }}> 
                                                                                      <h3 className="pt-5">
                                                            
                                                                                      No data found
                                                                                      </h3>
                                                                                    </TableCell>
                                                                                  </TableRow>
                                                                                )
                                                            
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    : (
                      paginatedData?.map((item, index) => (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell
                              component="td"
                              sx={{ cursor: "pointer" }}
                              onClick={() => toggleExpansion(index)}
                            >
                              {item.voucher_id}
                            </TableCell>
                            <TableCell component="td">
                              {item.travel_date}
                            </TableCell>
                            <TableCell component="td">
                              {item.travel_type || "--"}
                            </TableCell>
                          </TableRow>

                          {/* Expanded Row */}
                          {expandedRows[index] && (
                            <TableRow>
                              <TableCell component="td" colSpan={3}>
                                <div className="row">
                                  {[
                                    // {
                                    //   label: "Activity UID ",
                                    //   value: item.activity_uid,
                                    //   colClass: "col-6",
                                    // },
                                    {
                                      label: "No Of Seats ",
                                      value: item.no_of_seats || "--",
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "Vehicle No ",
                                      value: item.vehicle_no || "--",
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "Vehicle Company ",
                                      value: item.vehicle_company || "--",
                                      colClass: "col-6",
                                    },

                                    {
                                      label: "Travel Type Name ",
                                      value: item.transport_type_name || "--",
                                      colClass: "col-6",
                                    },
                                    {
                                      label: "Sector Name ",
                                      value: item.sector_name || "--",
                                      colClass: "col-6",
                                    },
                                  ].map((field, idx) => (
                                    <div
                                      key={idx}
                                      className={`${field.colClass} d-flex flex-column mb-3`}
                                    >
                                      <b>{field.label}:</b> {field.value}
                                    </div>
                                  ))}
                                     {Array.isArray(item["0"]) && (
                                  <div className="col-6 d-flex flex-column mb-3">
                                    <label htmlFor={`action-select-${index}`}><b>Action</b></label>
                                    <select
                                      id={`action-select-${index}`}
                                      className="form-select py-3"
                                      onChange={(e) => {
                                        const selected = e.target.value;
                                        console.log("Selected:", selected);
                                      }}
                                    >
                                      <option value="" selected disabled>-- Select an Action --</option>
                                      {item["0"].map((opt, idx) => (
                                        <option key={idx} value={opt.action.join(",")}>
                                          {opt.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                )}
                                </div>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))
                    )}
                  </TableBody>

                  {/* Pagination */}
                  <TablePagination
                    rowsPerPageOptions={[10, 15, 20]}
                    component="paper"
                    count={tableData3.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                      "& .MuiTablePagination-displayedRows": { margin: 0 },
                      "& .MuiTablePagination-selectLabel": { margin: 0 },
                      "& .MuiSelect-select": { margin: 0 },
                    }}
                  />
                </Table>
              </Paper>
            </div>
          </div>
        </LocalizationProvider>
      </MDBContainer>
      <div>
        <BottomNavigationBar />
      </div>
    </div>
  );
}

export default ArrivalDepartureGridFilter;
